<fd-dispatcher fd-dispatcher-action="{
    type: 'APPROVAL.APPROVE',
    approvalType: $ctrl.type,
    batch: $ctrl.batch
  }"><catch><wc-toast ng-init="$ctrl.catch()" wc-toast-message="Error approving changes"></wc-toast></catch><then><wc-toast ng-init="$ctrl.then()" wc-toast-message="Changes approved"></wc-toast></then></fd-dispatcher>